/**
 * @generated SignedSource<<c810f847dd8fb9b85bf94e22048ce2b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LandingPageHeroItemLinkPosition = "center" | "left" | "right" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ShopCarousel_landingPage$data = {
  readonly hero: {
    readonly items: ReadonlyArray<{
      readonly imageUrl: string | null;
      readonly linkPosition: LandingPageHeroItemLinkPosition | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShopBreadcrumbs_landingPage">;
  readonly " $fragmentType": "ShopCarousel_landingPage";
};
export type ShopCarousel_landingPage$key = {
  readonly " $data"?: ShopCarousel_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopCarousel_landingPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopCarousel_landingPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShopBreadcrumbs_landingPage"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandingPageHero",
      "kind": "LinkedField",
      "name": "hero",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LandingPageHeroItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkPosition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};

(node as any).hash = "66776a40d2fb6dd270af7454f1c1c082";

export default node;
